const iconsClassName = {
    normal: 'tw-text-neutral-light-600 dark:tw-text-neutral-dark-500',
    disabled: 'tw-text-light-500 dark:tw-text-neutral-dark-600',
    error: 'tw-text-alert-400 dark:tw-text-alert-300'
};
const generalContainerClassName = 'tw-w-full tw-rounded-1 tw-border tw-border-solid tw-flex tw-items-center tw-font-body4 tw-relative tw-overflow-hidden';
const containerLightClassName = 'tw-bg-neutral-light-100 tw-text-neutral-light-800';
const containerDarkClassName = 'dark:tw-bg-neutral-dark-700 dark:tw-text-neutral-light-100';
const stateContainerClassName = {
    normal: `${containerLightClassName} ${containerDarkClassName} tw-border-neutral-light-500 focus-within:tw-border-primary-light-500 dark:tw-border-transparent focus-within:dark:tw-border-primary-dark-300 hover:dark:tw-border-primary-dark-300 hover:tw-border-primary-light-500`,
    disabled: 'tw-text-neutral-light-500 dark:tw-bg-neutral-dark-500 tw-bg-neutral-light-400 dark:tw-text-neutral-dark-600 tw-border-transparent',
    error: `${containerLightClassName} ${containerDarkClassName} tw-border-alert-400 dark:tw-border-alert-300`
};
export { generalContainerClassName, iconsClassName, stateContainerClassName };
